const pages = {
  landings: [
    {
      title: 'overseas-expansion-research-and-evaluation',
      tText: 'overseas-expansion-research-and-evaluation',
      href: '/products/overseas-expansion-research-and-evaluation',
    },
    {
      title: 'overseas-strategy-planning',
      tText: 'overseas-strategy-planning',
      href: '/products/overseas-strategy-planning',
    },
    {
      title: 'global-work-force-strategy-consulting',
      tText: 'global-work-force-strategy-consulting',
      href: '/products/global-work-force-strategy-consulting',
    },
    {
      title: 'global-hr-management',
      tText: 'global-hr-management',
      href: '/products/global-hr-management',
    },
    {
      title: 'shared-hr-services',
      tText: 'shared-hr-services',
      href: '/products/shared-hr-services',
    },
    {
      title: 'talent-recruitment',
      tText: 'talent-recruitment',
      href: '/products/talent-recruitment',
    },
    {
      title: 'EOR',
      tText: 'eor',
      href: '/products/eor',
    },
    {
      title: 'Contractor',
      tText: 'contractor',
      href: '/products/contractor',
    },
    {
      title: 'Payroll',
      tText: 'payroll',
      href: '/products/global-payroll',
    },
    {
      title: 'Visa',
      tText: 'visa',
      href: '/products/global-visa',
    },
    {
      title: 'overseas-company-registration-and-secretarial-services',
      tText: 'overseas-company-registration-and-secretarial-services',
      href: '/products/overseas-company-registration-and-secretarial-services',
    },
    {
      title: 'EOR',
      tText: 'global-compliance-advisory-services',
      href: '/products/global-compliance-advisory-services',
    },
    {
      title: 'business-process-outsourcing-bpo',
      tText: 'business-process-outsourcing-bpo',
      href: '/products/business-process-outsourcing-bpo',
    },
    {
      title: 'overseas-human-resources-outsourcing-hro',
      tText: 'overseas-human-resources-outsourcing-hro',
      href: '/products/overseas-human-resources-outsourcing-hro',
    },
    {
      title: 'global-human-resource-management-platform',
      tText: 'global-human-resource-management-platform',
      href: '/products/global-human-resource-management-platform',
    },
  ],
  company: [
    {
      title: 'Energy',
      tText: 'globalExpansion',
      href: '/solutions/global-expansion',
    },
    {
      title: 'Compliant',
      tText: 'compliant',
      href: '/solutions/compliant',
    },
    {
      title: 'OnboardingPayroll',
      tText: 'onboardingPayroll',
      href: '/solutions/onboarding',
    },
  ],
  account: [
    // {
    //   title: 'Blog',
    //   tText: 'blog',
    //   href: '/account-general',
    //   completed: false,
    // },
    {
      title: 'Employment Guides',
      tText: 'employmentGuides',
      href: '/employment-guides',
    },
    // {
    //   title: 'Customer Stories',
    //   tText: 'customerStories',
    //   href: '/account-notifications',
    //   completed: false,
    // },
    // {
    //   title: 'Glossary',
    //   tText: 'glossary',
    //   href: '/account-billing',
    //   completed: false,
    // },
    {
      title: 'Cost Calculator',
      tText: 'costCalculator',
      href: '/tools/cost-calculator',
    },
  ],
  secondary: [
    {
      title: 'About us',
      tText: 'aboutUs',
      href: '/about-us',
    },
    {
      title: 'Join us',
      tText: 'joinUs',
      href: '/careers',
    },
    // {
    //   title: 'FAQ',
    //   href: '/faq',
    // },
    // {
    //   title: 'Error 404: Simple',
    //   href: '/not-found',
    // },
    // {
    //   title: 'Error 404: Cover',
    //   href: '/not-found-cover',
    // },
    // {
    //   title: 'Career Page Minimal',
    //   href: '/career-listing-minimal',
    // },
  ],
  blog: [
    {
      title: 'Reach View',
      href: '/blog-reach-view',
    },
    {
      title: 'Search',
      href: '/blog-search',
    },
    {
      title: 'Newsroom',
      href: '/blog-newsroom',
    },
    {
      title: 'Article',
      href: '/blog-article',
    },
  ],
  portfolio: [
    {
      title: 'Pricing View',
      tText: 'pricing',
      href: '/pricing',
    },
    // {
    //   title: 'Masonry',
    //   href: '/portfolio-masonry',
    // },
    // {
    //   title: 'Basic',
    //   href: '/portfolio-page',
    // },
    // {
    //   title: 'Parallax',
    //   href: '/agency',
    // },
  ],
};

export default pages;
